import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FLIP_MATCH_STATE_TYPE } from "containers/FlipMatch/constants";
import { switchCollection } from "../FlipMatch/thunks";
import FlipMatchState from "../FlipMatchState/FlipMatchState";

class FlipMatchSelect extends React.Component {

    handleSelectChange = (event) => {
        const { switchCollectionAction } = this.props;
        const selected = event.target.value;
        switchCollectionAction(selected);
    };

    render() {
        const { flip, name, className, emptyOption, t } = this.props;
        const options = Object.values(flip.collections || {}).map((value) => {
            const titleKey = `collection_${value.name}_title`;
            const title = t(titleKey, { defaultValue: value.title });
            return (
                <option key={value.name} value={value.name}>{title}</option>
            )
        });
        const placeholder = emptyOption != null ? emptyOption : t("please_select");
        return (
            <select value={flip.collection.name} name={name} className={className} onChange={this.handleSelectChange}>
                <option disabled value={false}>{placeholder}</option>
                {options}
            </select>
        )
    }
}

FlipMatchSelect.propTypes = {
    switchCollectionAction: PropTypes.func.isRequired,
    className: PropTypes.string,
    name: PropTypes.string,
    emptyOption: PropTypes.string,
    flip: FLIP_MATCH_STATE_TYPE,
    t: PropTypes.func.isRequired,
};

FlipMatchSelect.defaultProps = {
    className: '',
    name: '',
    emptyOption: null,
    flip: {}
};

const mapDispatchToProps = (dispatch) => ({
    switchCollectionAction: (collectionName) =>
        dispatch(switchCollection(collectionName)),
});

export default FlipMatchState(connect(
    null,
    mapDispatchToProps
)(withTranslation()(FlipMatchSelect)));